import * as React from "react";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOutlinedIcon from "@mui/icons-material/ThumbDownOutlined";
import { Box, Button } from "@talentpair/quantic";

export function VoteButtons({
  onUpvote,
  onDownvote,
}: {
  onUpvote: () => unknown;
  onDownvote: () => unknown;
}): React.ReactElement {
  const [vote, setVote] = React.useState<boolean | null>(null);
  return (
    <Box variant="row" layout="center-start" space={2}>
      <Button
        variant="icon"
        icon={vote === true ? ThumbUpIcon : ThumbUpOutlinedIcon}
        size="md"
        color={vote === true ? "primary" : "grey.500"}
        data-testid="upvote-button"
        onClick={() => {
          onUpvote();
          setVote(true);
        }}
      />
      <Button
        variant="icon"
        icon={vote === true ? ThumbDownIcon : ThumbDownOutlinedIcon}
        size="md"
        color={vote === false ? "amber.900" : "grey.500"}
        data-testid="downvote-button"
        onClick={() => {
          onDownvote();
          setVote(false);
        }}
      />
    </Box>
  );
}
